import { createSelector } from 'reselect'
import { RootStoreState } from '@src/models/app.types'

export const labResultsStateSelector = (state: RootStoreState) => state.labResults

export const healthMetricsSelector = createSelector(labResultsStateSelector, (labResultsStore) => {
  return labResultsStore.healthMetrics
})

const labResultsStatesSelector = createSelector(labResultsStateSelector, (labResultsStore) => {
  return labResultsStore.labResults
})

export const labResultsSelector = createSelector(
  labResultsStatesSelector,
  (labResults) => labResults?.labResults || [],
)

export const labResultsProcessingSelector = createSelector(
  labResultsStatesSelector,
  (labResults) => labResults?.labResultsProcessing || [],
)

export const labResultSelector = (id: string) =>
  createSelector(
    labResultsSelector,
    (labResults) => labResults.find((labResult) => labResult.id === id) || null,
  )
